import React from "react";
import { Track } from "../spotify/spotify";
import { ReactComponent as BackArrowIcon } from "../media/back_arrow.svg";

interface PlaylistCreatorProps {
    targetSong: Track;
    songs: Track[];
}

const PlaylistCreator: React.FC<PlaylistCreatorProps> = ({ targetSong, songs }) => {
    const allSongs = [targetSong, ...songs];
    return (
        <div className="column-centered">
            <div className='absolute top-3 left-3 row align-center mx-bw-5 cursor-pointer'><BackArrowIcon /><p>Create Different Group</p></div>
            <div className="column-centered my-3">
                <p className="mx-4 text-center">Group based on <b>{targetSong.name}</b> by <i>{targetSong.artists.map(a => a.name).join(', ')}</i>:</p>
                <p className="my-3">Create playlist with {songs.length + 1} songs?</p>
            </div>
            <div className="column track-list">
                { 
                    allSongs.map(song => (
                        <div key={song.id} className={`row align-center mx-bw-5`}>
                            { song.album.images.length > 0 && <img src={song.album.images[0].url} alt="img" className="album-art-img" /> }
                            <div className="flex-grow self-stretch row align-center cursor-pointer mx-bw-5 ml-1 md:ml-3">
                                <p className="">{song.name} by <i>{song.artists.map(a => a.name).join(', ')}</i></p>
                            </div>
                            { 
                                song.preview_url ?
                                <audio controls className="ml-auto">
                                    <source src={song.preview_url} type="audio/mp3" />
                                </audio> : 
                                <p className="opacity-50 ml-auto">(no preview available)</p>
                            }
                        </div>
                    ))
                }
            </div>
        </div>
    );
}

export default PlaylistCreator;
